import { render, staticRenderFns } from "./OccuranceForm.vue?vue&type=template&id=5d76ce72&"
import script from "./OccuranceForm.vue?vue&type=script&lang=js&"
export * from "./OccuranceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports